import React from "react";
import { RiCloseFill } from "react-icons/ri";

const SuccessModal = ({ closeModal, message, payAmount, Name }) => {
  const isMobile = window.innerWidth < 768;
  return (
    <div className="modal ">
      <RiCloseFill className='close-btn pointer' onClick={closeModal} />
      <div className="modal-contents flex flex-direction-v flex-v-center " style={isMobile ? { width: '90%' } : {}}>
        <div className="p-20 center-text">
          <div className="m-b-20" >
            <img src="/successHand.svg" alt="success-hand" />
          </div>
          <p>
            {payAmount > 0 ? (
              <>
                The payment of <span style={{fontWeight: "bold"}}>N{payAmount}</span> from {Name} was successful.
              </>
            ) : (
              <>
               {message ? message : "The payment was covered by the patient's HMO."}
              </>
            )}
          </p>
          <div className=" m-t-20 flex center-text">
            <button className="submit-btn" onClick={closeModal}>Continue</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
